<div class="container">
  <form *ngIf="form" [formGroup]="form" #FormWrapper="ngForm" class="form">
    <app-accordion
      [isStepper]="true"
      [isOpen]="activeStep === FormStep.Delivery"
      [hasStepperEdit]="isEditAvailable(FormStep.Delivery)"
      (toggled)="onEditClick(FormStep.Delivery)"
    >
      <ng-container stepperHeader>
        <h2 class="form__header">Delivery</h2>
      </ng-container>
      <ng-container content>
        <fieldset [formGroupName]="FormStep.Delivery">
          <legend class="sr-only">Delivery details and instructions</legend>
          <div class="mt-2 mb-4">
            <h4 class="mb-2">Your details</h4>
            <p>
              We’ll send you updates on your order by email and text message.
              The service provider will also contact you about the delivery
              time.
            </p>
          </div>

          <div class="address form-group">
            <h4 class="mb-2">Delivery address</h4>

            <p class="mb-1" [dgxQmSanitise]="'block'">
              {{ delCtrl(DeliveryControls.AddressLine1)?.value }}
            </p>
            <p class="mb-1" [dgxQmSanitise]="'block'">
              {{ delCtrl(DeliveryControls.AddressLine2)?.value }}
            </p>
            <p class="mb-1" [dgxQmSanitise]="'block'">
              {{ delCtrl(DeliveryControls.AddressLine3)?.value }}
            </p>
            <p class="mb-1" [dgxQmSanitise]="'block'">
              {{ delCtrl(DeliveryControls.AddressLine4)?.value }}
            </p>
            <p [dgxQmSanitise]="'block'">
              {{ delCtrl(DeliveryControls.PostCode)?.value }}
            </p>
          </div>

          <!-- Email -->
          <dgx-dfb-input
            [formControlName]="$any(emailFieldDef).controlName"
            [field]="$any(emailFieldDef)"
            [validate]="validateFormGroup || validateEmail"
          ></dgx-dfb-input>

          <!-- Mobile -->
          <dgx-dfb-input
            [formControlName]="$any(mobileFieldDef).controlName"
            [field]="$any(mobileFieldDef)"
            [validate]="validateFormGroup || validateMobile"
          ></dgx-dfb-input>

          <p class="notice-mobile">
            <span
              (click)="
                setTelephoneState(
                  delCtrl(DeliveryControls.IsTelephoneOpen).value
                )
              "
              class="link typog-body-bold"
              [class.link--primary]="
                !delCtrl(DeliveryControls.IsTelephoneOpen).value
              "
              ><span class="mr-2">Don’t have a mobile number?</span
              ><dgx-components-icon
                class="icon-chevron"
                [family]="'light'"
                [name]="
                  delCtrl(DeliveryControls.IsTelephoneOpen).value
                    ? 'chevron-up'
                    : 'chevron-down'
                "
                [size]="'sm'"
              ></dgx-components-icon
            ></span>
          </p>

          <!-- Telephone -->
          <div
            class="tel-optional-field"
            *ngIf="delCtrl(DeliveryControls.IsTelephoneOpen).value"
          >
            <div class="tel-optional-field-notice">
              You can enter a landline number instead.
            </div>
            <dgx-dfb-input
              [formControlName]="$any(telephoneFieldDef).controlName"
              [field]="$any(telephoneFieldDef)"
              [validate]="validateFormGroup || validateTelephone"
            ></dgx-dfb-input>
          </div>

          <h4 class="mb-2 mt-7">Delivery instructions</h4>

          <div class="form-question" *ngIf="productMeasurements">
            <dgx-form-field
              [errorsHidden]="validateFormGroup"
              [label]="checkSpecFieldDef?.label?.text"
              [labelHidden]="false"
              [formControlName]="checkSpecFieldDef?.controlName"
            >
              <small class="product-size d-block"
                >Product size: {{ productMeasurements }}</small
              >

              <dgx-form-radio
                class="flex"
                [options]="checkSpecFieldDef?.options"
              ></dgx-form-radio>
            </dgx-form-field>

            <div
              *ngIf="
                delCtrl(DeliveryControls.CheckSpecFieldDef)?.value === 'No'
              "
            >
              <ng-container
                *ngIf="
                  offers?.replacement_offers?.length > 1;
                  else chatWidgetPrompt
                "
              >
                <div
                  class="mt-4 form-question__notice form-question__notice--highlight"
                >
                  <p>If it won't fit, you can choose another one.</p>
                  <dgx-components-button-text
                    (clicked)="routePrompt(true)"
                    [iconName]="'arrow-right'"
                    [iconAlign]="'right'"
                    [tabIndex]="0"
                    [type]="'button-text'"
                  >
                    Go to browse products
                  </dgx-components-button-text>
                </div>
              </ng-container>

              <ng-template #chatWidgetPrompt>
                <div
                  class="mt-4 form-question__notice form-question__notice--highlight"
                >
                  <p>If it won't fit, please speak to us on live chat.</p>

                  <dgx-components-button-text
                    (clicked)="routePrompt(false)"
                    [iconName]="'arrow-right'"
                    [iconAlign]="'right'"
                    [tabIndex]="0"
                    [type]="'button-text'"
                  >
                    Open live chat
                  </dgx-components-button-text>
                </div>
              </ng-template>
            </div>
          </div>

          <div class="form-question">
            <dgx-form-field
              [errorsHidden]="validateFormGroup"
              [label]="productionConnectionFieldDef?.label?.text"
              [labelHidden]="false"
              [formControlName]="productionConnectionFieldDef?.controlName"
            >
              <dgx-form-radio
                class="flex"
                [options]="productionConnectionFieldDef?.options"
                [attr.id]="'productionConnectionFieldDefieldDef'"
              ></dgx-form-radio>
            </dgx-form-field>

            <div
              class="mt-4 form-question__notice"
              *ngIf="
                delCtrl(DeliveryControls.ProductionConnectionFieldDef)
                  ?.value === 'No'
              "
            >
              <p>
                Please make sure these connections are ready before delivery, or
                you won't be able to use your product.
              </p>
            </div>
          </div>

          <div class="form-question">
            <dgx-form-field
              [errorsHidden]="validateFormGroup"
              [label]="accessDifficultiesFieldDef?.label?.text"
              [labelHidden]="false"
              [formControlName]="accessDifficultiesFieldDef?.controlName"
            >
              <dgx-form-radio
                class="flex"
                [options]="accessDifficultiesFieldDef?.options"
                [attr.id]="'accessDifficulties'"
              ></dgx-form-radio>
            </dgx-form-field>

            <div
              class="mt-3 form-group form-group__textarea"
              *ngIf="
                delCtrl(DeliveryControls.AccessDifficulties).value === 'No'
              "
            >
              <p>
                <strong>
                  Please give some more details about parking access.
                </strong>
              </p>
              <p class="mb-4">
                Include anything you think the engineer will need to know. The
                engineer may need to contact you for further details.
              </p>
              <textarea
                class="form-control"
                [maxlength]="textAreaLimit"
                [attr.name]="DeliveryControls.AccessInfo"
                [formControlName]="DeliveryControls.AccessInfo"
              ></textarea>
              <span class="character-limit">
                {{
                  textAreaLimit -
                    delCtrl(DeliveryControls.AccessInfo).value?.length
                }}
                characters left
              </span>
            </div>
          </div>

          <!-- Stairs -->
          <div class="form-question">
            <dgx-form-field
              [errorsHidden]="validateFormGroup"
              [label]="stairsFieldDef?.label?.text"
              [labelHidden]="false"
              [formControlName]="stairsFieldDef?.controlName"
            >
              <dgx-form-radio
                class="flex"
                [options]="stairsFieldDef?.options"
                [attr.id]="stairsFieldDef?.controlName"
              ></dgx-form-radio>
            </dgx-form-field>
          </div>

          <div class="form-question">
            <div class="form-group form-group__textarea">
              <label [for]="DeliveryControls.AdditionalInfo">
                Are there any other details that could help us with your
                delivery?
              </label>
              <textarea
                class="form-control form-control--textarea"
                [id]="DeliveryControls.AdditionalInfo"
                [maxlength]="textAreaLimit"
                [attr.name]="DeliveryControls.AdditionalInfo"
                [formControlName]="DeliveryControls.AdditionalInfo"
              ></textarea>
              <span class="character-limit">
                {{
                  textAreaLimit -
                    delCtrl(DeliveryControls.AdditionalInfo).value?.length
                }}
                characters left
              </span>
            </div>
          </div>

          <ng-container *ngIf="!supplierToArrange">
            <ng-container class="form-question">
              <div class="form-group delivery-dates">
                <!-- Calendar -->
                <label class="mb-2" for="eDate"
                  ><strong>Choose date of delivery</strong></label
                >
                <div
                  class="form-group form-group__calendar"
                  [ngClass]="{
                    'is-invalid': isInvalid(DeliveryControls.ExpectedDate),
                    'is-valid': isValid(DeliveryControls.ExpectedDate)
                  }"
                >
                  <p-calendar
                    class="form-control form-control--calendar"
                    inputId="eDate"
                    showIcon="true"
                    dateFormat="dd/mm/yy"
                    dataType="string"
                    [minDate]="minimumDate"
                    [disabledDates]="disabledDates"
                    [maxDate]="maximumDate"
                    [icon]="(isLoading$ | async) ? '' : 'icon icon-calendar'"
                    selectOtherMonths="true"
                    placeholder="DD/MM/YYYY"
                    required="true"
                    [formControlName]="DeliveryControls.ExpectedDate"
                    (onShow)="onCalendarShow()"
                    (onHide)="onCalendarHide()"
                    (onSelect)="onDateSelect($event)"
                  >
                  </p-calendar>
                  <i class="icon icon-tick-circle icon--xxs"></i>
                  <i class="icon icon-error-circle icon--xxs"></i>
                  <div *ngIf="isLoading$ | async" class="spinner__wrapper">
                    <svg
                      viewBox="0 0 100 100"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle class="spinner-bg" cx="50" cy="50" r="45" />
                      <circle class="spinner" cx="50" cy="50" r="45" />
                    </svg>
                  </div>
                </div>
                <!-- Checkbox -->
                <div class="form-group checkbox">
                  <app-checkbox
                    [isChecked]="
                      delCtrl(DeliveryControls.FirstAvailableDate).value
                    "
                    [formControlName]="DeliveryControls.FirstAvailableDate"
                    [isDisabled]="
                      (isLoading$ | async) || (!minimumDate && !maximumDate)
                    "
                    (checked)="onCheckboxClick($event)"
                    >First available date
                  </app-checkbox>
                  <!-- Loading block -->
                  <div
                    *ngIf="isLoading$ | async"
                    class="form-group-block form-group__warning"
                    [@slideInOut]
                  >
                    <dgx-components-icon
                      [name]="'info-circle'"
                      [size]="'md'"
                    ></dgx-components-icon>
                    {{ DeliveryErrors.DeliveryDatesLoading }}
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Errors block-->
            <div class="form-group">
              <ng-container
                *ngIf="
                  (isLoading$ | async) === false && getErrorMessage$()
                    | async as errorMessage
                "
              >
                <div
                  class="form-group-block form-group__error error-state"
                  [@slideInOut]
                  [ngClass]="{
                    'no-dates': isInvalid(DeliveryControls.ExpectedDate)
                  }"
                >
                  <p>
                    <dgx-components-icon
                      [name]="'circle-exclamation'"
                      [size]="'md'"
                    ></dgx-components-icon>

                    {{ errorMessage }}
                  </p>

                  <dgx-components-button
                    *ngIf="
                      (deliveryDates$ | async)?.length === 0 &&
                      offers.replacement_offers.length > 1
                    "
                    [fill]="true"
                    (clicked)="routePrompt(true)"
                  >
                    Pick another product
                    <dgx-components-icon
                      name="arrow-right"
                    ></dgx-components-icon>
                  </dgx-components-button>
                </div>
              </ng-container>
              <!-- Genesys chat section -->
              <ng-container *ngIf="(deliveryDates$ | async)?.length === 0">
                <app-chat-support></app-chat-support>
              </ng-container>
            </div>
          </ng-container>
          <dgx-components-button
            *ngIf="(deliveryDates$ | async)?.length > 0 || supplierToArrange"
            [disabled]="
              delCtrl(DeliveryControls.CheckSpecFieldDef)?.value === 'No' ||
              (disableContinue && !supplierToArrange) ||
              (getErrorMessage$() | async) !== null
            "
            (clicked)="onContinueClick(FormStep.Delivery)"
            data-automation="deliveryContinue"
            class="delivery-continue"
            variant="primary"
            >Continue</dgx-components-button
          >
          <div
            class="form-question__warning mt-4"
            *ngIf="delCtrl(DeliveryControls.CheckSpecFieldDef)?.value === 'No'"
          >
            <dgx-components-icon
              [name]="'info-circle'"
              [size]="'sm'"
              class="mr-2"
            ></dgx-components-icon>
            <p>You’ve selected that the appliance won’t fit.</p>
          </div>
        </fieldset>
      </ng-container>
    </app-accordion>
    <app-accordion
      *ngIf="isProtectionSelected"
      [isStepper]="true"
      [isOpen]="activeStep === FormStep.DirectDebit"
      [hasStepperEdit]="isEditAvailable(FormStep.DirectDebit)"
      (toggled)="onEditClick(FormStep.DirectDebit)"
    >
      <ng-container stepperHeader>
        <h2 class="form__header">Monthly payment</h2>
      </ng-container>
      <ng-container content>
        <fieldset>
          <legend class="sr-only">
            Monthly payment and direct debit details
          </legend>
          <h4>Your protection policy</h4>
          <app-direct-debit
            [form]="form"
            [currentPlan]="currentPlan"
            [offers]="offers"
            [directDebitReuse]="directDebitReuse$ | async"
            [directDebitAutofillAvailable]="
              directDebitAutofillAvailable$ | async
            "
            [directDebitFormState]="
              completeOrderService.directDebitFormState$ | async
            "
            [replacementCost]="replacementCost$ | async"
            (continueClick)="onContinueClick($event)"
            (createOrderClick)="onCreateOrderClick()"
          ></app-direct-debit>
        </fieldset>
      </ng-container>
    </app-accordion>
    <app-accordion
      class="upfront-payment"
      [isStepper]="true"
      *ngIf="
        (completeOrderService.replacementCost$ | async) ||
        (additionalServicesService.isProtectionSelected$ | async) === false
      "
      [isOpen]="activeStep === FormStep.UpfrontPayment"
      [hasStepperEdit]="false"
    >
      <ng-container stepperHeader>
        <h2 class="form__header">
          <ng-container
            *ngIf="completeOrderService.replacementCost$ | async; else noCost"
          >
            One-off payment
          </ng-container>
          <ng-template #noCost> Summary </ng-template>
        </h2>
      </ng-container>
      <ng-container content>
        <fieldset>
          <legend class="sr-only">
            One-off payment summary and billing details
          </legend>
          <app-upfront-payment-summary
            [data]="upfrontPaymentSummary"
            [selected]="selected"
            [showTotal]="true"
            [isDirectDebitSummaryShown]="false"
          ></app-upfront-payment-summary>

          <app-worldpay-billing-address
            *ngIf="
              (completeOrderService.cardPaymentRedirectLoaded$ | async) &&
              (completeOrderService.replacementCost$ | async) &&
              activeStep === FormStep.UpfrontPayment
            "
            [currentPlan]="viewOffersService.currentPlan$ | async"
            [replacementCost]="completeOrderService.replacementCost$ | async"
            [contactDetails]="viewOffersService.contact$ | async"
            [deliveryAddress]="viewOffersService.deliveryAddress$ | async"
            [cardPaymentRedirect]="
              completeOrderService.cardPaymentRedirect$ | async
            "
          >
          </app-worldpay-billing-address>
          <div
            class="error--block text--center"
            *ngIf="completeOrderService.createOrderError$ | async"
          >
            Sorry, the system encountered a problem and could not create your
            order
          </div>

          <div
            class="error--block text--center"
            *ngIf="completeOrderService.cardPaymentRedirectError$ | async"
          >
            Sorry, the system could not connect to Worldpay, please try later
          </div>

          <dgx-components-button
            variant="primary"
            *ngIf="(completeOrderService.replacementCost$ | async) === 0"
            [disabled]="completeOrderService.createOrderError$ | async"
            (clicked)="onCreateOrderClick()"
            >Continue with order</dgx-components-button
          >
        </fieldset>
      </ng-container>
    </app-accordion>
  </form>

  <appCardPaymentRedirect
    [currentPlan]="viewOffersService.currentPlan$ | async"
    [replacementCost]="completeOrderService.replacementCost$ | async"
    [contactDetails]="viewOffersService.contact$ | async"
    [deliveryAddress]="viewOffersService.deliveryAddress$ | async"
  >
  </appCardPaymentRedirect>

  <div
    class="loading content"
    *ngIf="
      (completeOrderService.createOrderLoading$ | async) ||
      (completeOrderService.cardPaymentRedirectLoading$ | async) ||
      (completeOrderService.directDebitValidationLoading$ | async)
    "
  >
    <app-loader [@fadeInOut]></app-loader>
  </div>
</div>
